import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/use-auth';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useForm, SubmitHandler } from "react-hook-form";
import { CommonWrapper, CommonTitle, CommonSubText, CommonLabel, CommonInput, CommonSubmit, CommonLinkWrapper } from 'styles/styles';

interface Inputs {
  email: string,
  password: string,
};


const App = () => {
  const auth = useAuth();
  const navigate = useNavigate();


  const { register, handleSubmit, watch, formState: { errors } } = useForm<Inputs>();
  const onSubmit: SubmitHandler<Inputs> = async data => {
    const result = await auth.signIn(data.email, data.password);
    if (result.success) {
      navigate("/home");
    } else {
      alert(result.message);
    }
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <CommonWrapper>
          <CommonTitle>ログイン</CommonTitle>
          <CommonSubText>ログイン情報を入力してください。</CommonSubText>
          <CommonLabel htmlFor="email">メールアドレス</CommonLabel>
          <CommonInput {...register("email")} type="email" id="email" name="email" required placeholder='メールアドレス' />
          <CommonLabel htmlFor="password">パスワード</CommonLabel>
          <CommonInput {...register("password")} type="password" id="password" name="password" required placeholder='パスワード' />
          <CommonSubmit type="submit" value="ログイン" />
          <CommonLinkWrapper><Link to={"createadmin"}>新規アカウントの発行</Link></CommonLinkWrapper>
          <CommonLinkWrapper><Link to={"forget-password"}>パスワードを忘れた方はこちら</Link></CommonLinkWrapper>
        </CommonWrapper>
      </form>
    </>
  )
}

interface MyComponentProps {
  type: string;
}
const ConfirmForm: FC<MyComponentProps> = ({ type }) => {
  interface Inputs {
    verificationCode: string,
  };

  const auth = useAuth();
  const { register, handleSubmit, watch, formState: { errors } } = useForm<Inputs>();

  const onSubmit: SubmitHandler<Inputs> = async data => {
    let res: any;
    if (type === "sms-mfa") {
      res = await auth.confirmMFA(data.verificationCode);
    } else if (type === "email-sign-up") {
      res = await auth.confirmSignUp(data.verificationCode);
    }
    if (!res.success) {
      window.alert(res.message);
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <CommonWrapper>
          <CommonTitle>認証コード入力</CommonTitle>
          <CommonLabel htmlFor="verificationCode">認証コード:</CommonLabel>
          <CommonInput {...register("verificationCode")} type="verificationCode" id="verificationCode" name="verificationCode" required />
          <CommonSubmit type="submit" />
        </CommonWrapper>
      </form>
    </>
  )
}


const Tohome = () => {
  const navigate = useNavigate();

  useEffect(() => {
    alert("ログイン済みです");
    navigate("/home")
  }, [])


  return (
    <CommonWrapper>
      <CommonTitle>ログイン済</CommonTitle>
    </CommonWrapper>
  )
}

const SignIn = () => {
  const auth = useAuth();
  if (auth.isAuthenticated) {
    return <Tohome />
  } else if (auth.waitingForVerificationCodeInput) {
    return <ConfirmForm type={"email-sign-up"} />;
  } else if (auth.waitingForMFAVerificationCodeInput) {
    return <ConfirmForm type={"sms-mfa"} />;
  } else {
    return <App />;
  }
}

export default SignIn;
